import { EventRegistry } from '../../../../../domain/event/event.registry';
import { FieldEvent } from './field.event';
export class FieldArchivedEvent extends FieldEvent {
    constructor(payload, metadata, fromPersistence) {
        super({
            subject: `field/${payload.id}`,
            type: FieldArchivedEvent.type,
            payload,
            metadata,
            fromPersistence,
        });
    }
}
FieldArchivedEvent.type = 'com.treeplotter.api.field.archived.v1';
EventRegistry.register(FieldArchivedEvent.type, FieldArchivedEvent);
//# sourceMappingURL=field-archived.event.js.map